<div class="card-header">
  <div class="grid-x">
    <div class="cell auto">
      <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
    </div>
  </div>
</div>

<div class="card-body vertical-center">

  <div *ngIf="widget.size === WidgetSize.LARGE"
       class="d-block padding-h">
    <div class="grid-x">
      <div class="cell shrink">
        <div [chart]="chart"
             class="d-block margin-r"
             style="height: 96px;width:240px;"></div>
      </div>
      <div class="cell auto margin-l-l">
        <h4 class="font-500 margin-b">{{'widget.guaranty.beneficiary-distribution' | translate}}</h4>
        <div appEllipsisWithTooltip
             *ngFor="let item of legend">
          <span class="fas fa-circle c-fairways"
                [style.color]="item.color"></span>
          {{item.name}}
        </div>
      </div>
    </div>
  </div>

    <div *ngIf="widget.size === WidgetSize.SMALL"
         [chart]="chart"
         style="height: 96px">
    </div>
</div>

<div class="card-footer">
  <a class="button insito" [href]="goToRiskCapPage()" (click)="actionEvent.emit('widget.guaranty.analyse-ratio');">
    <span [title]="'widget.guaranty.analyse-ratio' | translate">{{'widget.guaranty.analyse-ratio' | translate}}</span>
  </a>
</div>
